module.exports = __webpack_public_path__ + "img/OM.3693f445.svg";